module.exports = __webpack_public_path__ + "img/Postmodernisme_Jostein-Gaarder.338b486f.jpg";